<template>
	<div id="InventariosDetail">
		<spinner v-if="isLoading" />
		<template v-else>
			<b-row id="mainContent">
				<!-- TABLAS DE ELEMENTOS -->
				<b-col xl="9" id="elementsHolder">
					<b-card v-if="!!selectedCatElements" no-body>
						<div slot="header">
							<b-row>
								<b-col cols="8" class="pt-2">
									<b v-if="filterTerm.length > 2 && filterAllCats == true">TODAS LAS CATEGORÍAS</b>
									<span v-else>
										<b>{{selectedCatElements.categoria|uppercase}}</b>
									</span>
									<template v-if="filterTerm.length > 2">
										<!-- <br> -->
										<i class="ml-1">(Filtrando "{{filterTerm}}")</i>
									</template>
								</b-col>
								<b-col cols="4">
									
									<b-input-group class="mt-0">
										<b-form-input placeholder="Filtrar" v-model="filterTerm" @change="makeBlinkBlink = null"></b-form-input>
										<template v-if="filterTerm.length > 2">
											<b-input-group-append>
												<b-button @click="filterTerm = ''" text="Button"><i class="fa fa-times"></i></b-button>
											</b-input-group-append>
										</template>
										<b-input-group-append v-if="filterTerm.length" is-text>
											<b-form-checkbox v-model="filterAllCats" switch class="mr-n2">
												<span class="sr-only">Switch for following text input</span> 
												<span v-if="filterAllCats">TODAS LAS CATEGORÍAS</span>
												<span v-else>ÉSTA CATEGORÍA</span>
											</b-form-checkbox>
										</b-input-group-append>
									</b-input-group>

								</b-col>
							</b-row>
						</div>
						<div id="mainData">
							<b-table class="mb-0"  fixed striped responsive :fields="fields" :items="filteredElements">
								
								<template #cell(elemento)="data">
									<div :class="{'animated flash -heartBeat text-info': (makeBlinkBlink == data.item.id)}"><i class="fa fa-search mr-1" v-if="makeBlinkBlink == data.item.id"></i>{{data.item.extended.titulo_extendido}}</div>
									<template v-if="filterTerm.length > 2 && filterAllCats">
										<small class="text-info" @click="selectedCat = data.item.categoria; makeBlinkBlink = data.item.id; filterAllCats = false">{{data.item.categoria|uppercase}}</small>
									</template>
								</template>

								<template #cell(inventario)="data">
									{{data.item.inventario_previo}}
								</template>

								<template #cell(existencia)="data">
									<!-- <span>{{data.item.inventario_nuevo}}</span> -->
									<b-input-group size="sm">
										<b-form-input @keyup.enter="$event.target.blur()" @blur="updateItem(data.item)" type="number" step="0.1" v-model="data.item.inventario_nuevo" :readonly="header.estatus == 'Cerrado'"></b-form-input>
											<!-- <b-input-group-append v-if="header.estatus == 'En curso'">
												<b-button @click="tryDeleteItem(data.item)" variant="outline-danger"><i class="fa fa-times"></i></b-button>
											</b-input-group-append> -->
									</b-input-group>
								</template>

								<template #cell(precio)="data">
									{{data.item.extended.precio | currency}}
								</template>

								<template #cell(costo)="data">
									{{data.item.extended.costo | currency}}
								</template>

								<template #cell(diferencia)="data">
									<span v-if="data.item.inventario_nuevo != null && data.item.inventario_nuevo != ''" :class="{plus: (data.item.inventario_nuevo * 1 > data.item.inventario_previo * 1), minus: (data.item.inventario_nuevo * 1 < data.item.inventario_previo * 1)}">
										<span class="processing" v-if="!!data.item.isUpdating" :key="data.item.id">
											<i class="fa fa-cog fa-spin"></i>
										</span>
										{{((data.item.inventario_nuevo - data.item.inventario_previo) *  data.item.extended.costo || 0) | currency}}
									</span>
									<span v-else>--</span>
								</template>

							</b-table>
						</div>
					</b-card>
				</b-col>
				<!-- FORMATO DE CABECERA -->

				<!-- COLUMNA DE CONTROLES GENERALES -->
				<b-col id="catsHolder">
					<b-card no-body h-eader="Categorías" id="categorias-list">
						<div slot="header" class="d-flex justify-content-between align-items-center mt-2 mb-2">
							Categorias
							<b-badge variant="primary" v-if="fullAdvance == 100" pill>%100</b-badge>
							<b-badge variant="light"  v-else-if="fullAdvance == 0"  pill>%0</b-badge>
							<b-badge variant="warning" v-else pill>%{{fullAdvance}}</b-badge>
						</div>
						<b-list-group flush>
							<b-list-group-item button v-for="(cat, $index) in categorizedElements" :key="$index" class="d-flex justify-content-between align-items-center" :active="cat.categoria == selectedCat" @click="selectedCat = cat.categoria">
								<span v-if="!!cat.categoria">{{cat.categoria | uppercase}}</span>
								<span v-else>-- Sin categoría --</span>
								<b-badge variant="primary" v-if="cat.advance == 100" pill>%100</b-badge>
								<b-badge variant="light"  v-else-if="cat.advance == 0"  pill>%0</b-badge>
								<b-badge variant="warning" v-else pill>%{{cat.advance}}</b-badge>
							</b-list-group-item>
						</b-list-group>
					</b-card>

					<b-card>
						<b-row>
							<b-col cols="5">
								<b-input-group size="sm" label-for="inv-estatus">
									<b-form-input id="inv-estatus" v-model="header.estatus" readonly />
								</b-input-group>
							</b-col>
							<b-col >
								<b-input-group size="sm" label-for="inv-saldo">
									<b-form-input id="inv-saldo" v-model="total" readonly/>
								</b-input-group>
							</b-col>
						</b-row>

						<b-input-group class="mt-3 mb-3" size="sm" prepend="Encargado" label-for="inv-nombre">
							<b-form-input id="inv-nombre" v-model="header.nombre" required :readonly="header.estatus == 'Cerrado'" />
						</b-input-group>

						<b-input-group size="sm" prepend="Comentarios" label-for="inv-comentarios">
							<b-form-textarea id="inv-comentarios" v-model="header.comentarios" required />
						</b-input-group>
					</b-card>

				</b-col>
				<!-- COLUMNA DE CONTROLES GENERALES -->
					
			</b-row>
			<b-row id="footer">
				<!-- ANEXIONADOR AL INVENTARIO -->
				<b-col cols="9" id="searchControl">
					<b-card v-if="header.estatus == 'En curso'">
						<b-row>
							<b-col cols="4">
								<b-form-input variant="primary" size="sm" id="inv-search" v-model="searchTerm"></b-form-input>
							</b-col>

							<b-col>
								<!-- <b-form-input v-model="preFetch.inventario" placeholder="Inventario" readonly/> -->
								<b-input-group size="sm" prepend="Inventario">
									<b-form-input v-model="preFetch.inventario" readonly></b-form-input>
								</b-input-group>
							</b-col>
							<b-col>
								<b-input-group size="sm" prepend="Existencia">
									<b-form-input @keyup.enter="addItem" v-model="existencia"></b-form-input>
								</b-input-group>
								<!-- <b-form-input v-model="existencia" placeholder="Existencia"/> -->
							</b-col>
							<!-- <b-col v-if="isSearching">
								<b-button size="sm" block> <i class="fa fa-cog fa-spin"></i> Procesando...</b-button>
							</b-col> -->
							<b-col cols="2">
								<b-button block size="sm" @click="addItem"  variant="info">Anexar</b-button>
							</b-col>
						</b-row>
						<!-- {{searchTerm}} -->
						<!-- <mobiscroll-input-search
							v-model="searchTerm"
							uri="origins/elementos/productos_overview"
							label="Buscador un ingrediente o artículo para inventariar" /> -->
					</b-card>
				</b-col>
				<!-- ANEXIONADOR AL INVENTARIO -->
				<!-- BOTONES DE CONTROL -->
				<b-col id="finishControl">
					<b-card v-if="isProcessing">
						<b-row align-h="end">
								<b-col><b-button size="sm" block> <i class="fa fa-cog fa-spin"></i> Procesando...</b-button></b-col>
						</b-row>
					</b-card>

					<b-card v-else-if="hasChangesInHeader">
						<b-row align-h="end">
							<b-col cols="5"><b-button size="sm" @click="resetHeader" block>Cancelar</b-button></b-col>
							<b-col><b-button variant="outline-primary" size="sm" @click="updateReport" block>Aplicar cambios</b-button></b-col>
						</b-row>
					</b-card>
					
					<b-card v-else-if="header.estatus == 'En curso'" class="text-right">
						<!-- <b-row align-h="end"> -->
							<!-- <b-col> -->
								<b-button-group size="sm">
									<b-button variant="danger" @click="tryDeleteThis"><i class="fa fa-trash"></i></b-button>
									<b-button blcok variant="primary" @click="tryToFinish">Finalizar</b-button>
								</b-button-group>
							<!-- </b-col> -->
						<!-- </b-row> -->
						<!-- <b-row align-h="end">
							<b-col cols="4">
								<b-button variant="danger" @click="tryDeleteThis" block>
									<i class="fa fa-trash"></i>
								</b-button>
							</b-col>
							<b-col>
								<b-button variant="primary" @click="tryToFinish" block>Finalizar</b-button>
							</b-col>
						</b-row> -->
					</b-card>
				</b-col>
				<!-- BOTONES DE CONTROL -->
			</b-row>
		</template>
	</div>
</template>

<script>
	import mobiscroll from "@mobiscroll/javascript";
	import axios from "axios";
	import _ from "lodash";
	import swal from 'sweetalert'

	let emptyPrefetch = {
		inventario: null
	}

	// import definicionCompras from './DefinicionCompras.vue'
	export default {
		name: 'InventariosDetail',
		components: {
			// definicionCompras
		},
		computed: {
			filteredElements(){
				if(!!this.filterTerm && this.filterTerm.length > 2 && !this.filterAllCats)
					return _.sortBy(_.filter(this.selectedCatElements.elementos, element => {
						let elTerminoRegEXP = new RegExp(_.escapeRegExp(this.filterTerm), 'i')
						if( elTerminoRegEXP.test(element.extended.titulo_extendido) )
							return true
					}), ['titulo_extendido'])
				else if(!!this.filterTerm && this.filterTerm.length > 2)
					return _.sortBy(_.filter(this.elementos, element => {
						let elTerminoRegEXP = new RegExp(_.escapeRegExp(this.filterTerm), 'i')
						if( elTerminoRegEXP.test(element.extended.titulo_extendido) )
							return true
					}), ['titulo_extendido'])
				else
					return _.sortBy(this.selectedCatElements.elementos, ['titulo_extendido'])
			},
			fullAdvance(){
				let sum = 0
				_.forEach(this.categorizedElements, cats => {
					sum += cats.advance
				})
				return parseFloat(sum / this.categorizedElements.length).toFixed(1)
			},
			selectedCatElements(){
				return _.find(this.categorizedElements, {categoria: this.selectedCat})
			},
			categorizedElements(){
				let categorias = []
				_.forEach(this.elementos, el => {
					if(!el.categoria)
						el.categoria = 'Sin categoría'
					categorias.push(el.categoria)
				})
				return _.sortBy(_.map(_.uniq(categorias), item => {
					let elementos = _.filter(this.elementos, {categoria: item}),
						advance = 0
					_.forEach(elementos, elemento=>{
						// console.log("elemento", elemento)
						if(!!elemento.inventario_nuevo && elemento.inventario_nuevo != '')
							advance ++
					})
					advance = parseInt(100 / elementos.length * advance)
					return {
						categoria: item,
						advance,
						elementos
					}
				}), 'categoria')
			},
			hasChangesInHeader(){
				return (JSON.stringify(this.headerClone) != JSON.stringify(this.header))
			},
			computedURI() {
				return axios.defaults.baseURL + "/origins/productos/";
			},
			fields(){
				return [
					{
						key: "elemento",
						label: "Artículo",
						// sortable: true,
					},
					{
						key: "costo",
						// sortable: true,
					},
					// {
						// key: "precio",
						// sortable: true,
					// },
					{
						key: "inventario",
						label: (this.header.estatus == 'En curso') ? "En inventario" : "Previo",
						// sortable: true,
					},
					{
						key: "existencia",
						// label: "Existencia",
						label: (this.header.estatus == 'En curso') ? "Existencia" : "Aplicación",
						// sortable: true,
					},
					{
						key: "diferencia",
						// label: "Inventario",
						// sortable: true,
					},
				]
			}
		},
		data: () => {
			return {
				isLoading: true,
				isProcessing: false,
				isSearching: false,

				filterTerm: '',
				filterAllCats: false,
				makeBlinkBlink: null, // elemento que brillará en caso de que le den clic a algún resultado de búsqueda.

				selectedCat: null,
				dataFilter: '',

				searchTerm: null, 	// término de búsqueda
				preFetch: _.clone(emptyPrefetch),		// definicion temporal de preLectura
				existencia: 0, 	// actualización de existencia actual
				total: 0,

				mobi: null,
				header: {
					id: null,
					nombre: null,
					created: null,
					finished: null,
					comentarios: null,
					estatus: null,
					saldo: null
				},
				headerClone: {
					id: null,
					nombre: null,
					created: null,
					finished: null,
					comentarios: null,
					estatus: null,
					saldo: null
				},
				elementos: []
			}
		},
		methods: {
			resetHeader(){
				this.header = _.cloneDeep(this.headerClone)
			},
			tryToFinish(){
				swal({
					text: '¿Estás seguro que deseas continuar? Se procederá a empatar el inventario real con el especificado en éste levantamiento. Posteriormente sólo podrás actualizar los comentarios.',
					icon: 'info',
					buttons: {
						cancel: 'Cancelar',
						proceed: 'Si'
					}
				}).then(selected => {
					if(selected == 'proceed') {
						// HE SAID YES!
						this.isProcessing = true
						axios.get('inventarios/finishreport/' + this.$route.params.id).then(response => {
							this.loadUpRefresh()
						}).catch(e=>{
							console.error(e)
							this.isProcessing = false
						})
					}
				})
			},
			updateReport(){
				// HE SAID YES!
				this.isProcessing = true
				axios.post('inventarios/reportupdate/' + this.$route.params.id, {header: this.header}).then(response => {
					if(response.status){
						this.headerClone = _.cloneDeep(this.header)
					}
					this.isProcessing = false
				}).catch(e => {
					console.error(e)
					this.isProcessing = false
				})
			},
			tryDeleteThis(){
				swal({
					text: '¿Estás seguro que deseas borrar éste levantamiento de inventario físico?',
					icon: 'info',
					buttons: {
						cancel: 'Cancelar',
						proceed: 'Si'
					}
				}).then(selected => {
					if(selected == 'proceed') {
						// HE SAID YES!
						this.isProcessing = true
						axios.delete('inventarios/report/' + this.$route.params.id).then(response => {
							if(response.status)
								this.$router.replace('/inventarios')
						})
					}
				})
			},
			updateItem(item){
				if(this.header.estatus == 'En curso' && item.inventario_nuevo != ''){
					item.costo_diferencial = ((item.inventario_nuevo - item.inventario_previo) *  item.extended.costo) || 0;
					let index = _.findIndex(this.elementos, {id: item.id})
					this.elementos[index].isUpdating = true
					this.updateGeneralSubtotal()
					axios.post('inventarios/updateitem', {item}).then(response => {
						this.elementos[index].isUpdating = false
						this.$forceUpdate()
					}).catch(e=>{
						console.error(e);
						this.elementos[index].isUpdating = false
						this.$forceUpdate()
					})
				}
			},
			tryDeleteItem(item){
				swal({
					text: '¿Estás seguro que deseas borrar éste registro?',
					icon: 'info',
					buttons: {
						cancel: 'Cancelar',
						proceed: 'Si'
					}
				}).then(selected => {
					if(selected == 'proceed') {
						// HE SAID YES!
						this.isLoading = true
						axios.delete('inventarios/reportitemdelete/' + item.id).then(response => {
							this.loadUpRefresh()
						}).catch(e=>{
							console.error(e)
							this.isLoading = false
						})
					}
				})
			},
			updateGeneralSubtotal(){
				let saldo = 0
				_.forEach(this.elementos, item => {
					if(item.inventario_nuevo != null)
						saldo += (parseFloat(item.costo_diferencial) ? parseFloat(item.costo_diferencial) : 0)
				})
				this.total = this.$options.filters.currency(saldo)
			},
			addItem(){
				// this.isLoading = true
				axios.post('inventarios/additem', {item: this.preFetch, existencia: this.existencia, inv_id: this.$route.params.id}).then(response => {
					console.log("response", response)
					this.loadUpRefresh()
					this.mobi.setVal(null, true, true)
				})
			},
			loadUpMobiscroll() {
				if(!this.mobi && this.header.estatus == 'En curso'){
					this.mobi = mobiscroll.select("#inv-search", {
						// display: "bottom",
						// theme: 'bootstrap',
						// anchor: "#" + this.idButtonMobiscrollTrigger,
						inputClass: 'form-control form-control-sm',
						placeholder: "Busca un ingrediente o artículo para anexarlo",
						fullData: [],
						filter: true,
						label: 'Busca el ingrediente o artículo que deseas ingresar al control de inventario',
						onSet: (a, b) => {
							this.isSearching = true
							axios.post('inventarios/reviewItem', {item: b.getVal(), inv_id: this.$route.params.id}).then(response => {
								// console.log("response", response)
								this.isSearching = false
								if(response.status)
									this.preFetch = response.data
								this.loadUpRefresh()
							}).catch(e => {
								this.isSearching = false
							})
						},
						data: {
							remoteFilter: true,
							url: this.computedURI,
							type: "json",
							processResponse: response => {
								this.fullData = [];
								if (response.status && response.data) {
									this.fullData = _.map(response.data, item => {
										return {
											value: item.value,
											text: item.text,
											html: `<p>${item.text}</p>`,
											item: _.clone(item)
										};
									});
								} else {
									this.fullData = [
										{
											value: null,
											text: "Nada encontrado",
											html: "<p>Nada encontrado</p>",
											item: {}
										}
									];
								}
								return this.fullData;
							}
						}
					});
				}
			},
			loadUpRefresh() {
				let url = "inventarios/getdetail/" + this.$route.params.id;
				axios.get(url).then((response) => {
					if (response.status) {
						this.isLoading = false;
						this.isProcessing = false;
						this.header = response.data.header;
						this.headerClone = _.cloneDeep(response.data.header);
						this.elementos = _.map(response.data.elements, item => {
							if(!!item.extended)
								item.titulo_extendido = item.extended.titulo_extendido; 
							else{
								// console.log('Item sin información', item)
								item.titulo_extendido = 'Sin información'; 
							}
						return item;});
						setTimeout(this.loadUpMobiscroll, 50)
					}
				});
			},
		},
		watch: {
			isLoading(){
				if(!this.isLoading){
					if(!!this.mobi && typeof this.mobi.destroy == 'function')
						this.mobi.destroy()
					this.mobi = null
				}
			},
			elementos(){
				this.updateGeneralSubtotal()
				if(!this.selectedCat)
					this.selectedCat = _.find(this.categorizedElements, item => {
						return (item.advance != 100)
					}).categoria
			},
			searchTerm(){
				this.preFetch = _.clone(emptyPrefetch)
			},
			preFetch(){
				this.existencia = this.preFetch.inventario
			}
		},
		mounted() {
			this.loadUpRefresh();
		}
	};

</script>

<style lang="less">
	#InventariosDetail {

		TABLE > thead:nth-child(1) > tr:nth-child(1) {
			& > th:nth-child(2), & > th:nth-child(3), & > th:nth-child(5) {
				width: 9em;
			}
			& > th:nth-child(4) {
				width: 12em;
			}
		}

		#categorias-list {
			.list-group-flush {
 				max-height: calc(100vh - 40em);
				overflow-y: auto;
			}
		}

		#mainData {
			.table-responsive {
				max-height: calc(100vh - 25.5em);
				overflow-y: auto;
			}
		}

		.plus {
			color: green;
		}
		.minus {
			color: red;
		}

	}
</style>
